import ReactDOM from 'react-dom';
import './index.scss';
import App from './containers/App';

ReactDOM.render(<App />, document.getElementById('root'));
